import React, { type FC } from 'react'

import { ModalConfirm } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  modalDeleteCancelCallback,
  modalDeleteConfirmCallback,
} from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/modals'
import { modalDeleteState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/modals'

const ModalDelete: FC = () => {
  const intl = useIntl()
  const { show, name } = useRecoilValue(modalDeleteState)

  const handleCancel = useRecoilCallback(modalDeleteCancelCallback, [])
  const handleConfirm = useRecoilCallback(modalDeleteConfirmCallback, [])

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage(
        {
          id: 'Load.AutomationWorkflow.ModalTitleDelete',
        },
        {
          name,
        },
      )}
      message={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ModalDeleteParagraph',
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant="delete"
    />
  )
}

export default ModalDelete
